<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Общая информация
        </h4>
      </div>

      <div class="card-body">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Название">
                <b-form-input
                  v-model.trim="organizer.name"
                  placeholder="Название организатора"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Телефон">
                <b-form-input
                  v-model.trim="organizer.phone"
                  placeholder="+79990001122"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <b-form @submit.prevent>
          <b-row>
            <b-col md="6">
              <b-form-group label="Мессенджеры (строкой)">
                <b-form-input
                  v-model.trim="organizer.messengers"
                  placeholder="Telegram"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <file-uploader
          v-model="organizer.photo_id"
          :default="organizer.photo"
          title="Фото организатора"
        />
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          Соц. сети
        </h4>
      </div>
      <div class="card-body">
        <div
          v-for="(link, idx) in organizer.social_networks_list"
          :key="`sn-${idx}`"
          class="social-row"
        >
          <b-form-input
            v-model.trim="link.code"
            class="social-row__input"
            placeholder="code (vk, telegram, instagram...)"
          />
          <b-form-input
            v-model.trim="link.url"
            class="social-row__input"
            placeholder="url"
          />
          <b-button
            variant="outline-danger"
            @click="removeSocial(idx)"
          >
            Удалить
          </b-button>
        </div>

        <b-button
          variant="primary"
          class="mt-1"
          @click="addSocial"
        >
          Добавить соц. сеть
        </b-button>
      </div>
    </div>

    <b-col>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="button"
        variant="primary"
        class="mr-1 save-button"
        :disabled="isLoading || !isValid"
        @click="saveItem"
      >
        <b-spinner
          v-if="isLoading"
          small
        />
        {{ isLoading ? 'Сохранение...' : 'Сохранить' }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import crudModule from '../../libs/crud_module'
import FileUploader from '../../global-components/FileUploader.vue'

const organizersModule = crudModule({
  entity_name: 'organizers',
})

const pickAllowedFields = obj => {
  const allowed = [
    'name',
    'phone',
    'messengers',
    'photo_id',
    'social_networks_list',
  ]
  const out = {}
  allowed.forEach(k => {
    if (Object.prototype.hasOwnProperty.call(obj, k)) out[k] = obj[k]
  })
  return out
}

const normalizeSocialNetworksList = list => (Array.isArray(list) ? list : [])
  .map(sn => ({
    code: sn && sn.code ? String(sn.code).trim() : undefined,
    url: sn && sn.url ? String(sn.url).trim() : undefined,
  }))
  .filter(sn => sn.code || sn.url)

const buildPatch = (current, original) => {
  const cur = pickAllowedFields(current)
  const orig = pickAllowedFields(original || {})
  const patch = {}

  // Scalars
  ;['name', 'phone', 'messengers', 'photo_id'].forEach(key => {
    if (cur[key] !== orig[key] && cur[key] !== undefined) patch[key] = cur[key]
  })

  // social_networks_list should overwrite only if changed
  const curSn = normalizeSocialNetworksList(cur.social_networks_list)
  const origSn = normalizeSocialNetworksList(orig.social_networks_list)
  if (JSON.stringify(curSn) !== JSON.stringify(origSn)) patch.social_networks_list = curSn

  return patch
}

export default {
  components: {
    FileUploader,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: false,
      organizer: {
        name: '',
        phone: '',
        messengers: '',
        photo_id: null,
        photo: null,
        social_networks_list: [],
      },
      _originalOrganizer: null,
    }
  },
  computed: {
    isValid() {
      return !!(this.organizer.name && this.organizer.name.trim())
    },
  },
  async created() {
    if (this.$route.params.id === 'new') return
    const result = await organizersModule.fetchItem(this.$route.params.id)
    const data = result.data || {}
    this.organizer = {
      name: data.name || '',
      phone: data.phone || '',
      messengers: data.messengers || '',
      photo_id: data.photo_id || (data.photo && data.photo.id) || null,
      photo: data.photo || null,
      social_networks_list: Array.isArray(data.social_networks_list)
        ? data.social_networks_list.map(sn => ({ code: sn.code || '', url: sn.url || '' }))
        : [],
      id: data.id,
    }
    this._originalOrganizer = JSON.parse(JSON.stringify(this.organizer))
  },
  methods: {
    addSocial() {
      this.organizer.social_networks_list.push({ code: '', url: '' })
    },
    removeSocial(idx) {
      this.organizer.social_networks_list.splice(idx, 1)
    },
    async saveItem() {
      if (!this.isValid) return
      this.isLoading = true
      try {
        if (this.$route.params.id === 'new') {
          const payload = pickAllowedFields({
            ...this.organizer,
            social_networks_list: normalizeSocialNetworksList(this.organizer.social_networks_list),
          })
          await organizersModule.createItem(payload)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Уведомление',
              icon: 'BellIcon',
              text: 'Организатор добавлен',
              variant: 'success',
            },
          })
          this.$router.push({ name: 'organizers' })
          return
        }

        const patch = buildPatch(
          {
            ...this.organizer,
            social_networks_list: this.organizer.social_networks_list,
          },
          this._originalOrganizer,
        )
        if (Object.keys(patch).length > 0) {
          await organizersModule.patchItem(this.organizer.id, patch)
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: 'Организатор сохранён',
            variant: 'success',
          },
        })
        this.$router.push({ name: 'organizers' })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: (error && error.response && error.response.data && error.response.data.message) || 'Ошибка сохранения',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.save-button {
  position: fixed !important;
  bottom: 30px;
  right: 15px;
  z-index: 1000;
}

.social-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;

  &__input {
    flex: 1;
  }
}
</style>

